import api from "./api";
import { apiDomain } from "./constants";

export async function getKpis() {
  const { data } = await api.get(`${apiDomain}/reports/kpis`);

  return data;
}

export async function getByModalities({ startDate, endDate }) {
  const { data } = await api.get(`${apiDomain}/reports/modalities`, {
    params: { startDate, endDate },
  });

  return data;
}

export async function getByCategories({ startDate, endDate }) {
  const { data } = await api.get(`${apiDomain}/reports/categories`, {
    params: { startDate, endDate },
  });

  return data;
}

export async function getOsEvolution({ startDate, endDate }) {
  const { data } = await api.get(`${apiDomain}/reports/evolution`, {
    params: { startDate, endDate },
  });

  return data;
}

export async function getTicketsByType({ startDate, endDate }) {
  const { data } = await api.get(`${apiDomain}/reports/ticket-by-type`, {
    params: { startDate, endDate },
  });

  return data;
}

export async function getIncidentsByCategory({ startDate, endDate }) {
  const { data } = await api.get(`${apiDomain}/reports/incidents-by-category`, {
    params: { startDate, endDate },
  });

  return data;
}

export async function getNewestTickets({ limit, offset } = { limit: 10, offset: 0 }) {
  const { data } = await api.get(`${apiDomain}/reports/tickets/newest`, {
    params: { limit, offset },
  });

  return data;
}

export async function getTodayTickets({ limit, offset } = { limit: 10, offset: 0 }) {
  const { data } = await api.get(`${apiDomain}/reports/tickets/today`, {
    params: { limit, offset },
  });

  return data;
}
